import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import AdminApp from './components/AdminApp.jsx'
import ToastProvider from './components/ui/toast/ToastProvider.jsx'

// Initialize i18n before rendering
import './i18n';

// Initialize PostHog analytics
import { initPostHog } from './analytics/posthog';
initPostHog();

// Import CSS in the correct order as per README
import './styles/variables.css'
import './styles/global.css'
import './styles/layout.css'
import './styles/pages/conversations.css'
import './styles/pages/widget-appearance.css'
import './styles/pages/broadcasts.css'
import './styles/pages/contacts.css'
import './styles/pages/segments.css'
import './styles/pages/pricing.css'
import './styles/pages/roles.css'
import './styles/pages/skills.css'
import './styles/pages/ai-tools.css'
import './styles/pages/integrations-detail.css'
// Responsive layout — imported LAST so its media-query rules win over the
// desktop defaults above (by source order) without needing !important.
import './styles/mobile.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <AdminApp />
      </ToastProvider>
    </BrowserRouter>
  </React.StrictMode>,
)